export const GET_DATA_FILE_CONTROL          = 'GET_DATA_FILE_CONTROL'
export const GET_DATA_FILE_CONTROL_CLONE    = 'GET_DATA_FILE_CONTROL_CLONE'
export const GET_DATA_TYPES_FILE_CONTROL    = 'GET_DATA_TYPES_FILE_CONTROL'
export const LOADING_FILE_CONTROL           = 'LOADING_FILE_CONTROL'